<script setup lang="ts">
import { TheNavbar, TheSnackbar } from '~/components';
import ArrowLeft from '~/components/icons/ArrowLeft.vue';

const route = useRoute();
const router = useRouter();

const showNavbar = computed((): boolean => {
  if (['showcase'].includes(route.name.split('-')[0])) {
    return false;
  }

  return true;
});

const hideNavbarOnMobile = computed((): boolean => {
  return !!route.path.match(/^\/manager\/job-sites\/\d+$/);
});

const backRoute = () => {
  if (window.history.state?.back) {
    router.back();
  } else {
    // If there's no history, navigate to the parent route (e.g., from /manager/job-sites/123 to /manager/job-sites)
    router.push(route.path.split('/').slice(0, -1).join('/') || '/');
  }
};
</script>

<template>
  <v-layout class="layout">
    <v-main>
      <ClientOnly>
        <div :class="{ 'hide-on-mobile': hideNavbarOnMobile }">
          <TheNavbar v-if="showNavbar" />
        </div>

        <div class="mobile-nav">
          <ArrowLeft @click="backRoute" />
        </div>
      </ClientOnly>

      <NuxtPage />
      <TheSnackbar />
    </v-main>
  </v-layout>
</template>

<style lang="scss" scoped>
.layout {
  @media (max-width: 959px) {
    background-color: rgb(var(--v-theme-surface-background-2)) !important;
  }

  .v-main {
    .mobile-nav {
      display: none;
    }

    @media (max-width: 959px) {
      padding-top: 0;
      .hide-on-mobile {
        display: none;
      }

      .mobile-nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        height: 72px;
      }
    }
  }
}
</style>
